import { useState, useEffect } from "react";
import InputFilter from "../../components/GInput/InputFilter";
import DropDownFilterSearch from "../../components/GDropDownList/DropDownFilterSearch";
import DropDownFilter from "../../components/GDropDownList/DropDownFilter";
import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { FaUserAlt, FaUserFriends } from "react-icons/fa";
import { FaUserCheck } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { MdPriceCheck } from "react-icons/md";
import InventoryIcon from '@mui/icons-material/Inventory';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function DeliveryBoysFilter ({ statusOfDeliveryBoys, values }) {

    const [value, setValue] = useState({});
    const [visible, setVisible] = useState(true);
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const handleVisible = () => {
        setVisible(!visible);
    }

    useEffect(() => {

        const updatedValue = values.reduce((acc, item) => ({
            phone: item.phone || acc.phone || "",
            available: item.available || acc.available || "",
            name: item.name || acc.name || "",
        }), {
            phone: "",
            available: "",
            name: "",
        });
        
        setValue(updatedValue);
        
    }, [values]);

    const handleValues = (key, v) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete(key);

        const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
        
        navigate(newUrl, { replace: true });

        setValue(prev => ({
            ...prev,
            [key]: ""
        }));
    };

    return (<>
        <AnimatePresence>
        {visible && (
            <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="grid grid-cols-1 md:grid-cols-4 gap-6 pb-6 overflow-hidden"
            >
            {[ 
                {
                title: "Session",
                value: 21459,
                percentage: 29,
                subtitle: "Total Users",
                icon: <FaUserAlt className="text-white" size={18} />,
                iconBg: "bg-purple-700"
                },
                {
                title: "Paid Users",
                value: 4567,
                percentage: 18,
                subtitle: "Last Week Analytics",
                icon: <FaUserPlus className="text-white" size={18} />,
                iconBg: "bg-red-700"
                },
                {
                title: "Active Users",
                value: 19860,
                percentage: -14,
                subtitle: "Last Week Analytics",
                icon: <FaUserCheck className="text-white" size={18} />,
                iconBg: "bg-green-700"
                },
                {
                title: "Active Users",
                value: 19860,
                percentage: -14,
                subtitle: "Last Week Analytics",
                icon: <FaUserCheck className="text-white" size={18} />,
                iconBg: "bg-green-700"
                }
            ].map((card, idx) => (
                <motion.div
                key={idx}
                initial={{ rotateY: 90, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                exit={{ rotateY: 90, opacity: 0 }}
                transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                className="w-full"
                style={{ transformStyle: "preserve-3d" }}
                >
                <StateCard {...card} />
                </motion.div>
            ))}
            </motion.div>
        )}
        </AnimatePresence>
        <div className=" bg-thirdly rounded-t-lg px-5 py-3">
            <div className="py-2 flex flex-row justify-between items-center">
                <p className="text-[22px] text-left font-semibold text-white">{currentLang === "en" ? "Filters" : "الفلاتر"}</p>
                {visible ? <FaArrowUp className="text-gray-300 text-xl cursor-pointer bg-furthly p-1 rounded-sm" onClick={handleVisible} /> : <FaArrowDown className="text-gray-300 text-xl cursor-pointer bg-secondary p-1 rounded-sm" onClick={handleVisible} />}
            </div>
            <div className="flex flex-col py-2 gap-4">
                <div className="flex sm:flex-row flex-col justify-between items-center gap-4">
                    <div className="w-full">
                        <InputFilter placeholder={t("filters.name")} type={"text"} paramkey="name"/>
                    </div>
                    <div className="w-full">
                        <InputFilter placeholder={t("filters.phone")} type={"number"} paramkey="phone"/>
                    </div>
                     <div className="w-full">
                        <DropDownFilter options={statusOfDeliveryBoys} value={value.available} defaultText={t("filters.delivery_status")} paramkey="available" />
                    </div>
                </div>
                <div className="flex flex-row flex-wrap justify-end items-center gap-5">
                    {Object.entries(value).map(([key, v]) => ( 
                        v != "" && <div className="bg-gray-600 text-white flex justify-between items-center gap-3 rounded-lg text-md px-3 py-[2px]"><button onClick={() => handleValues(key, v)} className="bg-red-500 w-4 h-4 rounded-full text-sm text-white text-bold flex justify-center items-center">X</button> {key}: {String(v)} </div>
                    ))}
                </div>
            </div>
        </div>
    </>)
}